const breakpoints = new Map([
  /**
   * Values are in pixels.
   *
   * These associations are biased towards the minWidth feature
   * because that is the one we'll most likely use the
   * most in media queries.
   *
   * You can always fallback to the size names in other
   * queries (xs, sm, md, etc.), i.e. sm === tablet,
   * md === laptop, et al.
   *
   * e.g.
   * 'phone' has a minimum width of 0, our design foundation
   * 'tablet' has a minimum width of 576
   * 'laptop' has a minimum width of 768
   * etc.
   *
   */
  ['xs:phone', 0],
  ['sm:tablet', 576],
  ['md:laptop', 768],
  ['lg:desktop', 992],
  ['xl:widescreen', 1200],
  ['xxl:television', 1400]
])
const features = {
  minWidth: {},
  maxWidth: {}
}

for (const [key, value] of breakpoints.entries()) {
  const [size, device] = key.split(':')

  features.minWidth[size] = features.minWidth[device] = `min-width: ${value}px`
  features.maxWidth[size] = features.maxWidth[device] = `max-width: ${value - 1}px`
}

Object.defineProperty(breakpoints, 'get', {
  value: keyParam => {
    for (const [key, value] of breakpoints.entries()) {
      if (key.includes(keyParam)) {
        return value
      }
    }
  }
})

export { breakpoints, features }
